<template>
    <div class="content-layout">
        <a-table size="middle" :pagination="false" :data-source="tableDate" class="product-table" rowKey="id"
            tableLayout="fixed" childrenColumnName="none">
            <template #title>
                <a-row :gutter="[12, 12]" type="flex" align="bottom" :style="{ width: '100%' }">
                    <a-col :style="{ width: '20%' }">
                        <span>
                            <div>操作模块过滤：</div>
                            <a-select v-model="listRequest.operationLogModule" :style="{ width: '100%' }" allow-clear
                                placeholder="请选择操作模块" option-filter-prop="label" @change="() => doSearch()">
                                <a-select-option v-for="(module, key) in $constRepository.opertaionLog.OperationLogModuleList" :key="key"
                                    :label="module.label"
                                    :value="module.label">{{ module.name }}</a-select-option>
                            </a-select>
                        </span>
                    </a-col>
                    <a-col :style="{ width: '20%' }">
                        <span>
                            <div>操作类型过滤：</div>
                            <a-select v-model="listRequest.operationLogType" :style="{ width: '100%' }" allow-clear
                                placeholder="请选择操作类型" option-filter-prop="label" @change="() => doSearch()">
                                <a-select-option v-for="(item, key) in $constRepository.opertaionLog.OperationLogTypeList" :key="key"
                                    :label="item.label"
                                    :value="item.label">{{ item.name }}</a-select-option>
                            </a-select>
                        </span>
                    </a-col>
                    <a-col :style="{ width: '20%' }">
                        <span>
                            <div>操作内容过滤：</div>
                            <a-input v-model="listRequest.operationLogContent" placeholder="请输入操作内容" class="w-full"
                                @search="() => doSearch()" />
                        </span>
                    </a-col>
                    <a-col :style="{ width: '30%' }">
                        <span>
                            <div>操作时间过滤：</div>
                            <a-range-picker :style="{width: '100%'}" v-model="timeRange" @change="() => doSearch()"  />
                        </span>
                    </a-col>
                    <a-col>
                        <a-button class="search-btn" type="primary" @click="doSearch">搜索</a-button>
                    </a-col>
                </a-row>
            </template>
            <a-table-column title="操作模块" key="operationLogModule" align="center">
                <template slot-scope="scope">
                    {{ $constRepository.opertaionLog.getOperationLogModuleNameByLabel(scope.operationLogModule) }}
                </template>
            </a-table-column>
            <a-table-column title="操作类型" key="operationLogType" align="center">
                <template slot-scope="scope">
                    {{ $constRepository.opertaionLog.getOperationLogTypeNameByLabel(scope.operationLogType) }}
                </template>
            </a-table-column>
            <a-table-column title="操作内容" key="operationLogContent" align="center">
                <template slot-scope="scope">
                    {{ scope.operationLogContent + `${scope.objectInfoName ? (`[${scope.objectInfoName}]`) : ''}` }}
                </template>
            </a-table-column>
            <a-table-column title="操作人" key="operationName" align="center">
                <template slot-scope="scope">
                    {{ scope.operationName }}
                </template>
            </a-table-column>
            <a-table-column title="操作时间" key="operationTime" align="center">
                <template slot-scope="scope">
                    {{ scope.operationTime ? moment(scope.operationTime).format('YYYY-MM-DD HH:mm:ss') : '-' }}
                </template>
            </a-table-column>
            <a-table-column title="客户端IP" key="operationIp" align="center">
                <template slot-scope="scope">
                    {{ scope.operationIp ? scope.operationIp : '-' }}
                </template>
            </a-table-column>
            <a-table-column title="操作状态" key="operationLogResult" align="center">
                <template slot-scope="scope">
                    {{ $constRepository.opertaionLog.getOperationLogResultNameByLabel(scope.operationLogResult) }}
                </template>
            </a-table-column>
            <a-table-column title="操作" key="action" width="18%" align="center">
                <template slot-scope="scope">
                    <a-button v-if="$hasPermissions(['rcs:operation_log:list'])" class="green-btn" ghost
                        @click="handleDetail(scope)">详情</a-button>
                </template>
            </a-table-column>
        </a-table>
        <div class="pagination">
            <a-pagination :current="pageInfo.page" :show-total="(total) => `共 ${pageInfo.totalElements} 条`"
                show-quick-jumper show-size-changer :total="pageInfo.totalElements" @showSizeChange="onShowSizeChange"
                @change="onChange" :pageSizeOptions="['10', '20', '30', '40']" />
            <br />
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'OperationLogManagement',
    components: {},
    mounted() {
        this.loadedPageData();
    },
    data() {
        return {
            tableDate: [],
            pageInfo: {
                page: 1,
                size: 10,
                totalElements: 0,
                totalPages: 0,
            },
            listRequest: {
                operationLogContent: '',
            },
            moment,
            timeRange: [],
        };
    },
    methods: {
        async fetchOperationLog() {
            this.listRequest.startTime = this.timeRange[0]
          ? this.timeRange[0].startOf('day').valueOf()
          : undefined;
          this.listRequest.endTime = this.timeRange[1]
          ? this.timeRange[1].endOf('day').valueOf()
          : undefined;
            const response = await this.$apiManager.operationLog.getOperationLogs(
                { ...this.listRequest, page: (this.pageInfo.page - 1), size: this.pageInfo.size },
            );
            this.tableDate = response.data.elements;
            this.$set(this.pageInfo, 'totalElements', response.data.totalElements);
            this.$set(this.pageInfo, 'totalPages', response.data.totalPages);
            this.$set(this.pageInfo, 'currentPage', response.data.currentPage);
        },
        doSearch() {
            this.pageInfo.page = 1;
            this.loadedPageData();
        },
        async loadedPageData() {
            await this.fetchOperationLog();
            if (this.pageInfo.currentPage + 1 > this.pageInfo.totalPages && this.pageInfo.currentPage) {
                this.pageInfo.page = 1;
                await this.fetchOperationLog();
            }
        },
        handleDetail(record) {
            this.$router.push({ name: 'OperationLogDetail', params: { id: record.id } });
        },
        onShowSizeChange(current, pageSize) {
            this.pageInfo.page = 1;
            this.$set(this.pageInfo, 'size', pageSize);
            this.loadedPageData();
        },
        onChange(pageNumber) {
            this.$set(this.pageInfo, 'page', pageNumber);
            this.loadedPageData();
        },
    },
    computed: {
    },
};
</script>

<style lang="less" scoped>
.content-layout {
    height: auto;
}

.product-table {
    margin-top: 1%;
}

.pagination {
    margin-top: 3%;
}

.green-btn {
    color: green;
    border: none;
}
</style>
